import { Component } from '@angular/core';

@Component({
  selector: 'pub-no-employee-selection',
  templateUrl: './no-employee-selection.component.html',
  styleUrls: ['./no-employee-selection.component.scss'],
})
export class NoEmployeeSelectionComponent {}
